/* eslint-disable react/prop-types */
import Image from "next/image";
import Link from "next/link";

const ProductAd = ({ ad }) => {
  if (!ad || !ad.link || !ad.image) return null;

  return (
    <div className="col-span-2 mb-3 md:mb-0">
      <Link href={ad.link}>
        <Image
          src={ad.image.url}
          alt={ad.image.alt ? ad.image.alt : ad.image.title}
          width={ad.image.width}
          height={ad.image.height}
        />
      </Link>
    </div>
  );
};

export default ProductAd;
